import styled from "@emotion/styled";
import { Grid, Paper, Typography } from "@mui/material";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    IconButton,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    TextareaAutosize,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

const SectionHeader = styled.div(({ theme }) => ({
    fontWeight: '700',
    fontSize: '15px',
    lineHeight: '20px',
    color: '#d41042',
    padding: '5px 0',
    boxShadow: 'none',
    marginTop: '18px'
}));

const SectionSubHeader = styled.div(({ theme }) => ({
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '18px',
    boxShadow: 'none',
    color: '#24211F',
    marginTop: '8px'
}));

const Context = styled.div(({ theme }) => ({
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    boxShadow: 'none',
    color: '#837e7e'
}));

const OderDetails = ({ details, statusList, closeViewDetailsDialog, handleStatusUpdate }) => {
    const [currentStatus, setCurrentStatus] = useState(details.vchStatus);
    return (
        <Dialog
            maxWidth="sm"
            fullWidth="false"
            sx={{ zIndex: 1000 }}
            open={true}
            onClose={closeViewDetailsDialog}
        >
            <DialogTitle sx={{ px: 1.5, lineHeight: 1.25 }} >
                Order Details
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={closeViewDetailsDialog}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers sx={{ p: 2 }}>
                <Grid container direction='row' justifyContent='center' alignItems='center' paddingBottom={'2px'} >
                    {/* <Grid item md={12}>
                        <SectionSubHeader>
                            Select Status
                        </SectionSubHeader>
                        <FormControl color="primary" sx={{ m: 1, minWidth: "45%", border: "none", margin: '0px' }}>
                            <RadioGroup
                                row
                                // value={selectedItem?.}
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            // onChange={(e) => handleChange(e.target.value, "vchPost")}
                            >
                                <FormControlLabel
                                    value="Accept Request"
                                    control={<Radio color="error" size="small" />}
                                    label={
                                        <span style={{ fontSize: "14px" }}>Accept Request</span>
                                    }
                                />
                                <FormControlLabel
                                    value="Reject Request"
                                    control={<Radio color="error" size="small" />}
                                    label={
                                        <span style={{ fontSize: "14px" }}>Reject Request</span>
                                    }
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid> */}
                    <Grid item md={12}>
                        <SectionSubHeader style={{ marginTop: '10px' }}>
                            Select Status
                        </SectionSubHeader>
                        <FormControl sx={{ m: 1, minWidth: "100%", border: "none", margin: '0px', }}>
                            <Select
                                // variant="filled"
                                size="small"
                                placeholder="Category"
                                value={currentStatus}
                                onChange={(e) => setCurrentStatus(e.target.value)}
                            >
                                {statusList?.map(({ id, name }) => (
                                    <MenuItem key={id} value={name}>
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>{" "}
                            {/* <div style={{ color: "red" }}>
                            {modified && (!selectedItem?.vchCategory || selectedItem?.vchCategory === "Please Select Category") && (
                                <FormHelperText style={{ color: "red" }}>
                                    {"Please Select Category"}
                                </FormHelperText>
                            )}
                        </div> */}
                        </FormControl>
                    </Grid>
                    <Grid item md={12}>
                        <SectionHeader>
                            Guest Information
                        </SectionHeader>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Name</SectionSubHeader>
                        <Context>{details.vchGuestName}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Business Name</SectionSubHeader>
                        <Context>{details.vchBusinessName}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Email</SectionSubHeader>
                        <Context>{details.vchGuestEmail}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Contact Number</SectionSubHeader>
                        <Context>{details.vchPhone}</Context>
                    </Grid>
                    <Grid item md={12} paddingY={'5px'}>
                        <SectionSubHeader>Pick-up or Delivery</SectionSubHeader>
                        <Context>{details.intCateringType}</Context>
                    </Grid>
                    <Grid item md={12}>
                        <SectionHeader>
                            Event Details
                        </SectionHeader>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Type of Event</SectionSubHeader>
                        <Context>{details.vchEventType}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Event Date and Time</SectionSubHeader>
                        <Context>{details.dteEventDate}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Number of Guests</SectionSubHeader>
                        <Context>{details.intTotalGuests}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Flavors</SectionSubHeader>
                        <Context>{details?.vchFlavors && JSON.parse(details.vchFlavors).map((flv) => flv.Flavor).join()}</Context>
                    </Grid>
                    <Grid item md={12} paddingY={'5px'}>
                        <SectionSubHeader>Add-ons + Specific Instructions</SectionSubHeader>
                        <Context>{details.vchAddonAndInstructions}</Context>
                    </Grid>
                    <Grid item md={12}>
                        <SectionHeader>
                            Delivery Address
                        </SectionHeader>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Venue Address</SectionSubHeader>
                        <Context>{details.vchAddress}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>City</SectionSubHeader>
                        <Context>{details.vchCity}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>State</SectionSubHeader>
                        <Context>{details.vchState}</Context>
                    </Grid>
                    <Grid item md={6} paddingY={'5px'}>
                        <SectionSubHeader>Zipcode</SectionSubHeader>
                        <Context>{details.vchZipCode}</Context>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outline"
                    style={{ border: "1px solid #D41042", color: "#D41042" }}
                    onClick={() => closeViewDetailsDialog()}
                >
                    Cancel
                </Button>
                <Button variant="contained"
                    style={{ border: "1px solid #D41042", backgroundColor: "#D41042" }}
                    onClick={() => handleStatusUpdate(currentStatus)}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog >
    );

}

export default OderDetails;